export default {
  "formstepform.basic.title": "Basic form",
  "formstepform.basic.description":
    "Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.",
  "formstepform.email.required": "Por favor insira seu email!",
  "formstepform.email.wrong-format": "O email está errado!",
  "formstepform.userName.required": "Por favor insira nome de usuário!",
  "formstepform.password.required": "Por favor insira sua senha!",
  "formstepform.password.twice": "As senhas não estão iguais!",
  "formstepform.strength.msg": "Por favor insira pelo menos 6 caracteres e não use senhas fáceis de adivinhar.",
  "formstepform.strength.strong": "Força: forte",
  "formstepform.strength.medium": "Força: média",
  "formstepform.strength.short": "Força: curta",
  "formstepform.confirm-password.required": "Por favor confirme sua senha!",
  "formstepform.phone-number.required": "Por favor insira seu telefone!",
  "formstepform.phone-number.wrong-format": "Formato de telefone errado!",
  "formstepform.verification-code.required": "Por favor insira seu código de verificação!",
  "formstepform.form.get-captcha": "Get Captcha",
  "formstepform.captcha.second": "sec",
  "formstepform.email.placeholder": "Email",
  "formstepform.password.placeholder": "Senha",
  "formstepform.confirm-password.placeholder": "Confirme a senha",
  "formstepform.phone-number.placeholder": "Telefone",
  "formstepform.verification-code.placeholder": "Código de verificação",
  "formstepform.form.optional": " (optional) ",
  "formstepform.form.submit": "Submit",
  "formstepform.form.save": "Save",
  "formstepform.title.label": "Title",
  "formstepform.title.placeholder": "Give the target a name",
  "formstepform.date.label": "Start and end date",
  "formstepform.placeholder.start": "Start date",
  "formstepform.placeholder.end": "End date",
  "formstepform.goal.label": "Goal description",
  "formstepform.goal.placeholder": "Please enter your work goals",
  "formstepform.standard.label": "Metrics",
  "formstepform.standard.placeholder": "Please enter a metric",
  "formstepform.client.label": "Client",
  "formstepform.label.tooltip": "Target service object",
  "formstepform.client.placeholder":
    "Please describe your customer service, internal customers directly @ Name / job number",
  "formstepform.invites.label": "Inviting critics",
  "formstepform.invites.placeholder": "Please direct @ Name / job number, you can invite up to 5 people",
  "formstepform.weight.label": "Weight",
  "formstepform.weight.placeholder": "Please enter weight",
  "formstepform.public.label": "Target disclosure",
  "formstepform.label.help": "Customers and invitees are shared by default",
  "formstepform.radio.public": "Public",
  "formstepform.radio.partially-public": "Partially public",
  "formstepform.radio.private": "Private",
  "formstepform.publicUsers.placeholder": "Open to",
  "formstepform.option.A": "Colleague A",
  "formstepform.option.B": "Colleague B",
  "formstepform.option.C": "Colleague C",
};
